import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OfflineRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleOffline = () => {
      navigate('/connection-terminated');
    };

    window.addEventListener('offline', handleOffline);
    return () => window.removeEventListener('offline', handleOffline);
  }, [navigate]);

  return null;
};

export default OfflineRedirect;
